import React from 'react';

import './Button.scss';
import { isExternalLink } from '../../helpers/link';

export default function Button(props) {
  return (
    <button className={`button ${getClassNameByColor(props.color?.trim())}`}>
      <a
        {...(isExternalLink(props.link) && {
          target: '_blank',
          rel: 'noopener noreferrer'
        })}
        href={props.link}
      >
        {props.label}
      </a>
    </button>
  );
}

function getClassNameByColor(color) {
  switch (color) {
    case 'red':
      return 'redButton';
    case 'blue':
      return 'blueButton';
    case 'white':
      return 'whiteButton';
  }
}
